<template>
  <ContentSection>
    <Container indent="container-tight">
      <div
        class="relative mx-auto mb-8 flex max-w-7xl flex-col justify-between rounded-lg border-3 border-current px-6 py-7 text-center text-blue-500 shadow-[0.5rem_0.5rem_currentColor] green:text-green-500 pink:text-pink-500 lg:flex-row lg:pl-16 lg:pr-12 lg:text-left"
      >
        <!-- IMAGE -->
        <div class="flex flex-col justify-center pb-6">
          <AppImage
            v-if="data.person?.portrait"
            loading="lazy"
            :src="data.person?.portrait"
            :aspect-ratio="1"
            class="mx-auto h-32 w-32 min-w-[8rem] overflow-hidden rounded-full"
          />
        </div>
        <div class="h-[inherit] w-[0.09375rem] bg-amber-100" />
        <div class="lg:w-9/12">
          <div
            class="text-sm text-gray-800 prose-strong:font-medium md:text-base"
            v-html="data.content"
          />
          <div class="my-8">
            <NuxtLink
              v-if="telLink"
              class="hyphens-auto focus-default -ml-3 block pl-3 text-base outline-none hover:underline xs:text-lg md:text-xl xl:text-2xl"
              :to="telLink"
              >{{ data?.person?.phone }}</NuxtLink
            >
            <EmailLink
              v-if="data?.person?.email"
              v-slot="{ href, address }"
              :email="data.person.email"
            >
              <AppLink
                class="hyphens-auto focus-default -ml-3 block break-words pl-3 text-base underline outline-none xs:text-lg md:text-xl xl:text-2xl"
                :to="href"
                >{{ address }}</AppLink
              >
            </EmailLink>
          </div>

          <p class="leading-[1.125rem] md:text-2xs font-medium uppercase">
            {{
              Array.isArray(data?.person?.categories) &&
              data?.person?.categories.length > 0
                ? data?.person?.categories.map((f) => f.title).join(', ')
                : data?.person?.categories[0]?.title
            }}
          </p>
        </div>
      </div>
    </Container>
  </ContentSection>
</template>

<script setup>
const props = defineProps({
  data: { type: Object, required: true },
})

let telLink = computed(() => {
  const phone = props.data?.person?.phone
  if ((phone && typeof phone === 'string') || phone instanceof String) {
    return 'tel:' + phone.replace(/\s/g, '')
  }
  return null
})
</script>
